import { Search } from "lucide-react";
import { InputHTMLAttributes } from "react";
import { cn } from "../../../utils/classes";
import styles from "./search-input.module.css";

export type SearchInputProps = InputHTMLAttributes<HTMLInputElement> & {
  wrapperClassName?: string;
};

/**
 * Global header search box (`design.md` "top-header" search slot — see
 * `<TopHeader search={...}>`). Uncontrolled by default (spread `value`/
 * `onChange` in if a consumer needs to control it) since no app wired to
 * this yet has a real search backend — this is presentational chrome, not a
 * working search.
 */
export function SearchInput({
  className,
  wrapperClassName,
  placeholder = "Search or ask me anything",
  type = "search",
  ...props
}: SearchInputProps) {
  return (
    <div className={cn(styles.wrapper, wrapperClassName)}>
      <Search className={styles.icon} aria-hidden="true" />
      <input
        type={type}
        className={cn(styles.input, className)}
        placeholder={placeholder}
        {...props}
      />
    </div>
  );
}
